import type { Locale } from "@/lib/i18n";
import { pl, type WMenuTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

/**
 * WMenu translations — scoped per-locale.
 *
 * Consume w komponencie przez `useT(wMenuTranslations)`:
 *   const t = useT(wMenuTranslations);
 *   t.empty // -> "Brak pozycji w menu." (pl) | "No menu items." (en) | ...
 */
export const wMenuTranslations: Record<Locale, WMenuTranslations> = {
  pl,
  en,
  de,
};

export type { WMenuTranslations };
